import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { SystemPopup } from '@gongxigames/framework/slot/types';
import { MultiSetsPromotionModule, MultiSetsPromotionModuleEvents } from '@gongxigames/framework/promotions';

export class MultiSetsPromotionEndState extends ModuleState<null, MultiSetsPromotionModule, MultiSetsPromotionModuleEvents> {
    private endPopup!: SystemPopup;

    public onEnterState(): void {
        const frData = this.module.getPromotion().getData();

        this.endPopup = this.module.popups.createMultiSetsPromotionEndPopup({
            ...frData,
            onClickOk: this.onClickOk.bind(this),
        });

        this.module.showPopup(this.endPopup);
    }

    private onClickOk(): void {
        this.module.hidePopup(this.endPopup);
        this.module.endPromotion();
    }

    public onLeaveState(): void {
        this.emit('General.Slot.SPIN.ENABLE', MultiSetsPromotionModule.NAME);
    }
    protected setupEvents(): void {}
}
